import React from 'react';
import PropTypes from 'prop-types';
import style from "../../../styles/styles";
import {Paper, List, Subheader, TextField} from 'material-ui';
import Loading from "../../common/Loading/Loading";
import withTranslation from "../../../hoc/withTranslation";

class PushSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func
    };

    static defaultProps = {
        app: null,
        loading: false
    };

    handleServerId = (event) => {
        let value;
        if (!event.target.value) {
            value = null;
        } else {
            value = event.target.value;
        }
        this.props.editConfiguration('push_server_id', value);
    };
    handleServerKey = (event) => {
        let value;
        if (!event.target.value) {
            value = null;
        } else {
            value = event.target.value;
        }
        this.props.editConfiguration('push_server_key', value);
    };
    handleServerTokenDev = (event) => {
        let value;
        if (!event.target.value) {
            value = null;
        } else {
            value = event.target.value;
        }
        this.props.editConfiguration('push_server_token_dev', value);
    };
    handleServerTokenProd = (event) => {
        let value;
        if (!event.target.value) {
            value = null;
        } else {
            value = event.target.value;
        }
        this.props.editConfiguration('push_server_token_prod', value);
    };

    render() {
        const {loading, app} = this.props;
        let content;
        if (loading) {
            content = <Loading paper={false}/>;
        } else {
            content = <div>
                <TextField
                    floatingLabelText={this.props.t('module.push.push_server_id')}
                    defaultValue={app.configurations.push_server_id}
                    fullWidth={true}
                    onBlur={this.handleServerId}
                />
                <TextField
                    floatingLabelText={this.props.t('module.push.push_server_key')}
                    defaultValue={app.configurations.push_server_key}
                    fullWidth={true}
                    onBlur={this.handleServerKey}/>
                <TextField
                    floatingLabelText={this.props.t('module.push.push_server_token_dev')}
                    defaultValue={app.configurations.push_server_token_dev}
                    fullWidth={true}
                    onBlur={this.handleServerTokenDev}/>
                <TextField
                    floatingLabelText={this.props.t('module.push.push_server_token_prod')}
                    defaultValue={app.configurations.push_server_token_prod}
                    fullWidth={true}
                    onBlur={this.handleServerTokenProd}/>
            </div>
        }

        return <Paper>
            <List>
                <Subheader style={{...style.subHeader, ...style.relative}}>
                    {this.props.t('module.push.platinium')}
                </Subheader>

                <div style={style.paper}>
                    {content}
                </div>
            </List>
        </Paper>
    }
}

export default withTranslation(PushSetting);



// WEBPACK FOOTER //
// src/components/common/PushSetting/PushSetting.js